import { Link } from 'react-router-dom';
import { Users, Shield, Clock, LogOut, Eye, RefreshCw, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCompany } from '../context/CompanyContext';

export function SuperAdminPage() {
  const { user } = useAuth();
  const { companies, isLoading } = useCompany();

  if (!user || user.role !== 'superadmin') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-4">
        <div className="text-center">
          <AlertCircle className="w-16 h-16 mx-auto mb-4 text-[color:var(--b2b-danger)]" />
          <h1 className="text-2xl font-bold mb-4">Acceso denegado</h1>
          <p className="b2b-muted mb-4">Solo el SuperAdmin puede acceder a esta sección</p>
          <Link to="/" className="b2b-btn b2b-btn--primary">Volver al inicio</Link>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-4">
        <div className="text-center">
          <Users className="w-12 h-12 mx-auto mb-4 opacity-40 animate-spin" />
          <p className="b2b-muted">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div className="space-y-1">
          <span className="b2b-eyebrow">SuperAdmin</span>
          <h1 className="text-3xl font-extrabold tracking-tight">Panel SuperAdmin</h1>
          <p className="b2b-muted">Control global de empresas y usuarios</p>
        </div>
        <Link to="/superadmin/users" className="b2b-btn b2b-btn--primary">
          <Users className="w-4 h-4" />
          Gestión de usuarios
        </Link>
      </div>

      <div className="b2b-bento">
        <div className="b2b-card b2b-col-4">
          <span className="b2b-card__label">Empresas registradas</span>
          <span className="b2b-card__value">{companies.length}</span>
        </div>
        <div className="b2b-card b2b-col-4">
          <span className="b2b-card__label">Administrador</span>
          <span className="text-lg font-semibold break-all">{user.name}</span>
          <span className="block text-xs b2b-muted break-all">{user.email}</span>
        </div>
        <div className="b2b-card b2b-card--accent b2b-col-4">
          <span className="b2b-icon"><Shield className="w-5 h-5" /></span>
          <span className="b2b-card__label">Nivel de acceso</span>
          <span className="text-lg font-semibold">Control total del sistema</span>
        </div>
      </div>

      <div className="b2b-panel">
        <div className="b2b-panel__head">
          <h2 className="text-lg font-semibold">Empresas registradas</h2>
          <span className="text-sm b2b-muted">{companies.length}</span>
        </div>
        {companies.length === 0 ? (
          <div className="p-8 text-center b2b-muted">
            <Users className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p>No hay empresas registradas</p>
            <p className="mt-1 text-sm">Los usuarios se registran desde la página pública</p>
          </div>
        ) : (
          companies.map(company => (
            <Link key={company.id} to={`/superadmin/companies/${company.id}`} className="b2b-panel__row">
              <span className="b2b-icon"><Shield className="w-5 h-5" /></span>
              <span className="flex-1 min-w-0">
                <span className="block font-medium truncate">{company.name}</span>
                <span className="block text-sm b2b-muted">{company.cif || 'Sin CIF'}</span>
              </span>
              <span className="b2b-pill">IVA {company.vatRate || 21}%</span>
              <Eye className="w-4 h-4 b2b-muted" />
            </Link>
          ))
        )}
      </div>

      <div className="flex flex-wrap gap-3 pt-6 border-t border-[var(--b2b-border)]">
        <Link to="/superadmin/logs" className="b2b-btn b2b-btn--ghost">
          <Clock className="w-4 h-4" />
          Ver logs del sistema
        </Link>
        <Link to="/superadmin/backup" className="b2b-btn b2b-btn--ghost">
          <RefreshCw className="w-4 h-4" />
          Crear respaldo
        </Link>
        <button
          onClick={() => alert('Cerrar sesión')}
          className="b2b-btn b2b-btn--danger"
        >
          <LogOut className="w-4 h-4" />
          Cerrar sesión (SuperAdmin)
        </button>
      </div>
    </div>
  );
}
